module.exports = __webpack_public_path__ + "static/img/profile-icon02.2fa32eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon02.png
// module id = 2950
// module chunks = 1